import { Component } from '@angular/core';

@Component({
    selector: 'apcam-main-layout',
    imports: [],
    templateUrl: './main-layout.component.html',
    styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {}
